"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CandidateAccountSettingsContract = void 0;
const core_1 = require("@ts-rest/core");
const schemas_1 = require("../../../schemas");
const settings_request_1 = require("./settings.request");
const settings_response_1 = require("./settings.response");
const c = (0, core_1.initContract)();
exports.CandidateAccountSettingsContract = c.router({
    find: {
        description: 'Get employee account settings details.',
        summary: 'Get employee account settings details',
        method: 'GET',
        path: '/',
        responses: { 200: settings_response_1.AccountSettingsResponseSchema },
    },
    update: {
        description: 'Partially update employee account settings (e.g., company offer, email distribution).',
        summary: 'Update employee account settings',
        method: 'PATCH',
        path: '/',
        body: settings_request_1.CandidateUpdateAccountSettingsBodySchema,
        responses: { 200: (0, schemas_1.createEmptySuccessResponseSchema)() },
    },
}, {
    pathPrefix: '/settings',
    strictStatusCodes: true,
    commonResponses: {
        400: schemas_1.BaseErrorResponseSchema,
        401: schemas_1.BaseErrorResponseSchema,
        500: schemas_1.BaseErrorResponseSchema,
    },
});
